module.exports = __webpack_public_path__ + "img/unique-2-xxl.65810e1.webp";